/* Exige declarar mesa (o recoger/domicilio) antes de pagar.
   Guarda el dato como atributo del carrito para que llegue a la orden. */
(function () {
  var KEY = 'don_mesa';
  var back, input, err, pending = null, cartAttr = null;

  function q(sel, root) { return (root || document).querySelector(sel); }

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cartAttr = (c && c.attributes && c.attributes.Mesa) ? String(c.attributes.Mesa) : '';
        return cartAttr;
      })
      .catch(function () { return ''; });
  }

  function saveMesa(v) {
    try { localStorage.setItem(KEY, v); } catch (e) {}
    cartAttr = v;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { Mesa: v } })
    });
  }

  function build() {
    if (back) return;
    back = document.createElement('div');
    back.className = 'mg-back';
    back.innerHTML =
      '<div class="mg-box" role="dialog" aria-modal="true" aria-labelledby="mg-t">' +
        '<h3 id="mg-t">¿A qué mesa lo llevamos?</h3>' +
        '<p>Escribe el número que está en tu mesa. Así la barra sabe a dónde va tu pedido.</p>' +
        '<input class="mg-in" type="text" inputmode="numeric" maxlength="6" placeholder="N°" aria-label="Número de mesa">' +
        '<p class="mg-err">Escribe el número de tu mesa o elige recoger.</p>' +
        '<div class="mg-actions">' +
          '<button type="button" class="mg-btn" data-mg-ok>Confirmar mesa</button>' +
          '<button type="button" class="mg-btn mg-btn--ghost" data-mg-away>Es para recoger o domicilio</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(back);
    input = q('.mg-in', back);
    err = q('.mg-err', back);

    q('[data-mg-ok]', back).addEventListener('click', function () {
      var v = (input.value || '').replace(/[^0-9A-Za-z]/g, '').slice(0, 6);
      if (!v) { err.classList.add('is-on'); input.focus(); return; }
      saveMesa('Mesa ' + v).then(go);
    });

    q('[data-mg-away]', back).addEventListener('click', function () {
      saveMesa('Para recoger / domicilio').then(go);
    });

    back.addEventListener('click', function (e) {
      if (e.target === back) close();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); q('[data-mg-ok]', back).click(); }
    });
  }

  function open() {
    build();
    err.classList.remove('is-on');
    var prev = '';
    try { prev = localStorage.getItem(KEY) || ''; } catch (e) {}
    input.value = prev.replace(/\D/g, '');
    back.classList.add('is-open');
    setTimeout(function () { input.focus(); }, 60);
  }

  function close() { if (back) back.classList.remove('is-open'); pending = null; }

  function go() {
    var el = pending;
    close();
    if (!el) return;
    if (el.tagName === 'A' && el.href) { window.location.href = el.href; return; }
    var form = el.closest('form');
    if (form) { form.submit(); return; }
    el.click();
  }

  function isCheckout(el) {
    if (!el) return false;
    if (el.matches('[name="checkout"]')) return true;
    if (el.tagName === 'A' && el.getAttribute('href') && el.getAttribute('href').indexOf('/checkout') === 0) return true;
    return false;
  }

  readCart();

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[name="checkout"], a[href^="/checkout"]') : null;
    if (!isCheckout(el)) return;
    if (cartAttr) return;
    e.preventDefault();
    e.stopPropagation();
    pending = el;
    open();
  }, true);
})();